import Legal from './Legal';
import withLayout from 'hocs/withLayout';

/** Content column max width `640px` (`SITE_LAYOUT.layoutContentSm`), with horizontal padding. */
export default withLayout(Legal, { contentWidth: 'sm', margin: true });
